/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Pill from '@ingka/pill';
import Text from '@ingka/text';
import React from 'react';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/pill/dist/style.css';
import '@ingka/focus/dist/style.css';
import IcCross from '@ingka/ssr-icon/paths/cross-small';
import styles from './PillsToolbar.module.css';
import { isNullEmptyOrUndefined } from '../../../../../common/services/commonService.js';
import { useTranslate } from '../../../../../common/services/translationService.js';

interface PillsToolbarProps {
  data: any;
  hfbData: any;
  totalUnits: any;
  onRemoveFilter: (newPayload: any, newHfbData: any,) => void;
  onClearAll: () => void;
  setMyCustomUnit: (isMyCustomUnit: boolean) => void;
}

enum FilterType {
  hfb = 'HFB',
  pra = 'PRA',
  pa = 'PA',
  ru = 'RU',
  CustUnit = 'My custom kitchen unit'
}

const PillsToolbar = ({
  data,
  hfbData,
  totalUnits,
  onRemoveFilter,
  onClearAll,
  setMyCustomUnit,
}: PillsToolbarProps) => {
  const removeItemFromArray = (arr:any[], value: any) => {
    const index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  };

  const removeCommon = (first: any, second: any) => {
    const combine = [...first, ...second];
    return combine.filter((el) => !(first.includes(el) && second.includes(el)));
  };

  const removeHfbItemFromArray = (payload: any, hfbDataList: any, filter: any) => {
    const hfbFilterData: any = [];
    if (!isNullEmptyOrUndefined(payload.praId) || !isNullEmptyOrUndefined(payload.paID)) {
      hfbFilterData.push(hfbDataList.filter((item: any) => filter.includes(item.slice(0, 2))));
      return removeCommon(hfbFilterData[0], hfbDataList);
    }
    return hfbDataList.filter((item: any) => payload.hfbId.includes(item.slice(0, 2)));
  };

  const removePraItemFromArray = (payload: any, hfbDataList: any, filter: any) => {
    const praFilterData: any = [];
    if (!isNullEmptyOrUndefined(payload.hfbId) || !isNullEmptyOrUndefined(payload.paId)) {
      praFilterData.push(hfbDataList.filter((item: any) => filter.includes(item.slice(0, 3))));
      return removeCommon(praFilterData[0], hfbDataList);
    }
    return hfbDataList.filter((item:any) => payload.praId.includes(item.slice(0, 3)));
  };

  const removeFilter = (filterVal: any, type: FilterType) => {
    const tempPayload = { ...data };
    let tempHfbData = [...hfbData];
    switch (type) {
      case FilterType.hfb:
        tempPayload.hfbId = removeItemFromArray(tempPayload?.hfbId, filterVal);
        tempHfbData = removeHfbItemFromArray(tempPayload, tempHfbData, filterVal);
        break;
      case FilterType.pra:
        tempPayload.praId = removeItemFromArray(tempPayload?.praId, filterVal);
        tempHfbData = removePraItemFromArray(tempPayload, tempHfbData, filterVal);
        break;
      case FilterType.pa:
        tempPayload.paId = removeItemFromArray(tempPayload?.paId, filterVal);
        tempHfbData = removeItemFromArray(tempHfbData, filterVal);
        break;
      case FilterType.CustUnit:
        tempPayload.userId = null;
        setMyCustomUnit(false);
        break;
      default: break;
    }
    onRemoveFilter(tempPayload, tempHfbData);
  };

  const buildLabel = (type: FilterType, filter: any) => {
    if ([FilterType.hfb,
      FilterType.pra,
      FilterType.pa,
      FilterType.ru,
      FilterType.CustUnit].includes(type)) {
      return filter?.label || filter;
    }
    return `${type}: ${filter?.label || filter?.text || filter}`;
  };

  const renderPills = (filterList: any[], type: FilterType) => {
    const valueArray = [...filterList];
    return valueArray?.map((filter: any) => (
      !isNullEmptyOrUndefined(filter) && (
      <Pill
        key={`${type}${filter?.label || filter?.text || filter}`}
        className={`${styles.pill} ${styles.pillBorder} noselect`}
        label={buildLabel(type, filter)}
        small
        ssrIcon={IcCross}
        onClick={() => {
          const val = filter;
          removeFilter(val, type);
        }}
      />
      )
    ));
  };

  return (
    <div className={styles.pillsContainer}>
      {data?.hfbId?.length > 0 ? (
        renderPills(data?.hfbId, FilterType.hfb)
      ) : null}
      {data?.praId?.length > 0 ? (
        renderPills(data?.praId, FilterType.pra)
      ) : null}
      {data?.paId?.length > 0 ? (
        renderPills(data?.paId, FilterType.pa)
      ) : null}
      {!isNullEmptyOrUndefined(data?.userId) ? (
        renderPills([FilterType.CustUnit], FilterType.CustUnit)
      ) : null}
      <Pill
        className={`${styles.pill} noselect`}
        label={useTranslate('find.comp.clearAll')}
        small
        onClick={onClearAll}
      />
      {totalUnits > 0 ? (
        <Text className={styles.fcTotalCount}>
          {`(${totalUnits} Custom kitchen unit${totalUnits > 1 ? 's' : ''})`}
        </Text>
      ) : null}
    </div>
  );
};

export default PillsToolbar;
